import { SET_FILE } from "./types";

export const seterrorFile = (data: any): any => ({
  type: SET_FILE,
  payload: data,
});
